<template>
  <div class="data-table">
    <div class="table-container">
      <table class="table" aria-label="AI compatibility table">
        <thead>
          <tr class="header-row">
            <th 
              v-for="(item, index) in table_header" 
              :key="index" 
              class="header-cell" 
              role="columnheader" 
              scope="col"
            >
              {{ item }}
            </th>
          </tr>
        </thead>
        <tbody class="table-content">
          <tr 
            v-for="(row, index) in table_body" 
            :key="index"
            class="table-row"
          >
            <td 
              v-for="(cel, key) in row" 
              :key="key" 
              class="table-cell"
              v-html="cel"
            >
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
</template>

<script>
  import TableCustom from "@/components/helpers/Table_custom.vue";
  import Vue from 'vue';

  export default {
    name: 'TableCustom',
    props: {
      table_header: {type: Array},
      table_body: {type: Array},
      table_obj: {type: Object}
    },
    data() {
      return {
      };
    },
    computed: {
    },
    mounted() {
      const MyComponentConstructor = Vue.extend(TableCustom);
      const table = new MyComponentConstructor();
    }  
  }
</script>

<style lang="scss" scoped>
  .data-table {
    width: 100%;
    border-radius: 8px;
    background-color: var(--color-surface);
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.06);
    margin-bottom: 32px;
    overflow: hidden;
    border: 1px solid var(--color-outline);
    transition: all 0.2s ease;
  }

  .table-container {
    width: 100%;
    overflow-x: auto;
    max-height: 400px;
    overflow-y: auto;
    scrollbar-width: thin;
    scrollbar-color: var(--color-muted) var(--color-surface);
    
    &::-webkit-scrollbar {
      height: 6px;
      width: 6px;
    }
    
    &::-webkit-scrollbar-track {
      background: var(--color-surface);
      border-radius: 3px;
    }
    
    &::-webkit-scrollbar-thumb {
      background-color: var(--color-muted);
      border-radius: 3px;
      border: 1px solid var(--color-surface);
    }
  }

  .table {
    width: 100%;
    border-collapse: separate;
    border-spacing: 0;
    white-space: nowrap;
    font-size: 13px;
    table-layout: fixed;
  }

  .header-row {
    height: 44px;
    background-color: var(--color-background);
    border-bottom: 1px solid var(--color-outline);
  }

  .header-cell {
    color: var(--color-text-secondary);
    font-weight: 600;
    text-align: center;
    text-transform: uppercase;
    padding: 0 12px;
    height: 44px;
    letter-spacing: 0.3px;
    font-size: 11px;
    transition: background-color 0.2s ease;
    vertical-align: middle;
  }

  .table-row {
    height: 40px;
    border-bottom: 1px solid var(--color-outline);
    transition: background-color 0.2s ease;
    
    &:nth-child(even) {
      background-color: rgba(0, 0, 0, 0.02);
    }
    
    &:last-child {
      border-bottom: none;
    }
    
    &:hover {
      background-color: var(--color-active-surface);
    }
  }

  .table-cell {
    padding: 6px 12px;
    height: 40px;
    text-align: center;
    color: var(--color-text-primary);
    font-size: 13px;
    vertical-align: middle;
    font-weight: normal;
  }

  // Material icons styling
  .material-icons-outlined {
    font-family: 'Material Icons Outlined';
    font-weight: normal;
    font-style: normal;
    font-size: 16px;
    line-height: 1;
    letter-spacing: normal;
    text-transform: none;
    display: inline-block;
    white-space: nowrap;
    word-wrap: normal;
    direction: ltr;
    -webkit-font-feature-settings: 'liga';
    -webkit-font-smoothing: antialiased;
    
    &.red {
      color: #d32f2f;
    }
    
    &.green {
      color: #388e3c;
    }
  }

  // Link styling for dynamically rendered content
  ::v-deep a {
    color: var(--color-highlight);
    text-decoration: none;
    
    &:visited {
      color: var(--color-highlight);
    }
    
    &:hover {
      color: var(--color-highlight);
      text-decoration: none;
    }
    
    &:active {
      color: var(--color-highlight);
    }
  }

  // Responsive design
  @media (max-width: 768px) {
    .data-table {
      margin-bottom: 24px;
    }
    
    .header-cell {
      font-size: 10px;
      padding: 0 8px;
    }
    
    .table-cell {
      font-size: 12px;
      padding: 4px 8px;
    }
  }

  @media (max-width: 480px) {
    .header-cell {
      font-size: 9px;
      padding: 0 6px;
    }
    
    .table-cell {
      font-size: 11px;
      padding: 3px 6px;
    }
  }
</style>
